import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

import './DowngradeModal.sass';

export const DowngradeModal = ({toggleUpsellModal, confirmDowngrade}) => (
  <div className="create-flow__downgrade-modal">
    <div
      className="create-flow__downgrade-modal-overlay"
      onClick={() => toggleUpsellModal()}
      role="button"
      aria-label="Toggle upsell modal"
      onKeyUp={toggleUpsellModal}
      tabIndex={0}
    />
    <div className="create-flow__downgrade-modal-content">
      <button
        className="create-flow__upsell-modal-close-btn"
        onClick={() => toggleUpsellModal()}
        type="button"
        aria-label="Toggle upsell modal"
        onKeyUp={toggleUpsellModal}
      >
        <CloseLineIcon ratio={0.75} />
      </button>
      <Typography
        as="label"
        className="create-flow__downgrade-modal-label"
        variant="header5"
        data-qa-id="createFlowDowngradeModalLabel"
        color="shadow"
      >
        Are you sure you want to downgrade?
      </Typography>
      <Typography
        as="p"
        className="create-flow__downgrade-modal-description"
        variant="paragraph2"
        data-qa-id="createFlowDowngradeModalDescription"
        color="shadow"
      >
        By switching to basic, you&apos;ll lose all Premium customizations
      </Typography>
      <div className="create-flow__downgrade-modal-footer">
        <Button
          className="create-flow__downgrade-modal-back-btn"
          data-qa-id="save-changes-no"
          variant="secondary"
          size="large"
          ariaLabel="Downgrade"
          onClick={() => {
            confirmDowngrade();
          }}
        >
          Switch to basic
        </Button>
        <Button
          className="create-flow__downgrade-modal-downgrade-btn"
          data-qa-id="save-changes-yes"
          data-impression-tracking="true"
          variant="primary"
          size="large"
          ariaLabel="Stay in Premium"
          onClick={() => {
            toggleUpsellModal();
          }}
        >
          Stay in Premium
        </Button>
      </div>
    </div>
  </div>
);
